import { render, staticRenderFns } from "./documentPage.vue?vue&type=template&id=55d84bf2&scoped=true&"
import script from "./documentPage.vue?vue&type=script&lang=js&"
export * from "./documentPage.vue?vue&type=script&lang=js&"
import style0 from "./documentPage.vue?vue&type=style&index=0&id=55d84bf2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55d84bf2",
  null
  
)

export default component.exports